<template>

<div>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Configurações de Lâmpadas</h4>
    </div>
    <div class="card-content">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <p class="category">
              <strong>Quantidade máxima de lâmpadas por cliente que podem ser trocadas no projeto:</strong>
            </p>
            <input
              type="number"
              name="lampsMax"
              v-validate="modelValidations.lamps.max"
              v-model.number="project.lamps.max"
              class="form-control"
            >
            <small
              class="text-danger"
              v-show="modelValidations.lamps.max.invalid"
            >{{ errors.first('lampsMax') }}
            </small>
          </div>
        </div>

        <div class="col-xs-12">
          <div class="form-group">
            <p class="category">
              Haverá <strong>controle</strong> de lâmpadas por temporada?
            </p>
            <p-radio
              inline
              v-model="project.lamps.hasSeason"
              label="true"
            >Sim
            </p-radio>
            <p-radio
              inline
              v-model="project.lamps.hasSeason"
              label="false"
            >Não
            </p-radio>
          </div>
        </div>

        <div
          class="col-xs-12"
        >
          <!-- v-if="project.lamps.hasSeason.toString() === true" -->
          <div class="form-group">
            <p class="category">
              Período máximo <strong>(em meses)</strong> que o cliente ficará sem poder trocar lâmpada
            </p>
            <input
              type="number"
              min="1"
              max="120"
              name="lampsMax"
              v-model="project.lamps.seasonRange"
              class="form-control"
            >
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LampsConfigForm',
  computed: {
    ...mapGetters('project', { modelValidations: 'validations' }),
    project: {
      get () {
        return this.$store.state.project.one
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Project/LampsConfigForm.vue